import { gql } from "@apollo/client";
import { DocumentType } from "@api/graphql/generated/generated-types";
import { CompliancePolicyFields } from "./queries";

export interface UpsertCompliancePolicyData {
  upsertDriverCompliancePolicy: CompliancePolicyFields;
}

export interface UpsertCompliancePolicyVars {
  courierId: string;
  entityId: string;
  requiredDocumentTypes?: DocumentType[];
  warnedDocumentTypes?: DocumentType[];
  excludedDocumentTypes?: DocumentType[];
}

export const UPSERT_COMPLIANCE_POLICY = gql`
  mutation UpsertDriverCompliancePolicy(
    $courierId: ID!
    $entityId: ID!
    $requiredDocumentTypes: [DocumentType!]
    $warnedDocumentTypes: [DocumentType!]
    $excludedDocumentTypes: [DocumentType!]
  ) {
    upsertDriverCompliancePolicy(
      courierId: $courierId
      entityId: $entityId
      requiredDocumentTypes: $requiredDocumentTypes
      warnedDocumentTypes: $warnedDocumentTypes
      excludedDocumentTypes: $excludedDocumentTypes
    ) {
      id
      entityId
      requiredDocumentTypes
      warnedDocumentTypes
      excludedDocumentTypes
    }
  }
`;
